import type { ISummaryCurrencyFooter } from '../../models/ISummaryDualCurrency';
import { formatSummaryFooterText } from '../../utils/summaryDisplayUtils';
import './summaryFooter.css';

type Props = {
  footer?: ISummaryCurrencyFooter;
};

const SummaryFooter = ({ footer }: Props) => {
  if (!footer) {
    return null;
  }

  const totalInEur = Number.isFinite(footer.TotalInEur) ? footer.TotalInEur : 0;

  return (
    <div className="summary-footer-banner">
      <span className="summary-footer-banner__text">
        {formatSummaryFooterText(totalInEur, footer.EurToUsdExchangeRate)}
      </span>
    </div>
  );
};

export default SummaryFooter;
